import React from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

interface AdvancedPaginationProps {
  currentPage: number;
  pageSize: number;
  totalItems: number;

  onPageChange: (page: number) => void;
}

const CommunicationPagination: React.FC<AdvancedPaginationProps> = ({
  currentPage,
  pageSize,
  totalItems,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalItems / pageSize) || 1;

  const handlePageChange = (page: number) => {
    const newPage = Math.max(1, Math.min(page, totalPages));
    onPageChange(newPage);
  };

  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="d-flex justify-content-end mt-3">
      <Pagination
        className="mail-pagination pagination-primary mb-0"
        aria-label="Item navigation"
      >
        <PaginationItem disabled={currentPage === 1}>
          <PaginationLink
            previous
            onClick={() => handlePageChange(currentPage - 1)}
            href="#"
          />
        </PaginationItem>

        {Array.from({ length: totalPages }, (_, index) => index + 1).map(
          (page) => (
            <PaginationItem key={page} active={currentPage === page}>
              <PaginationLink onClick={() => handlePageChange(page)} href="#">
                {page}
              </PaginationLink>
            </PaginationItem>
          )
        )}

        <PaginationItem disabled={currentPage === totalPages}>
          <PaginationLink
            next
            onClick={() => handlePageChange(currentPage + 1)}
            href="#"
          />
        </PaginationItem>
      </Pagination>
    </div>
  );
};

export default CommunicationPagination;
